export default __webpack_public_path__ + "static/0103-1466a0f08bbc1ba6647e5bce8f406ac6.png";